const Insights = () => {
  return (
    <div className="max-w-6xl mx-auto">
      <h1 className="text-4xl font-bold text-gray-800 mb-4">Insights</h1>
      <p className="text-gray-600">Campaign analytics and performance insights coming soon...</p>
    </div>
  );
};

export default Insights;
